import { Injectable } from "@angular/core";
import { EsAdditionalProduct } from "@edp-models/ES/es-product.model";
import { ProductEsService } from "@edp-services/ES/product-es.service";
import { EEsProductActions, GetAdditionalProductEs, SetAdditionalProductEs } from "@edp-store/actions/ES/product-es.actions";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, mergeMap, switchMap } from "rxjs/operators";

@Injectable()
export class EsProductEffects {
    @Effect()
    loadAdditionalProduct$ = this.actions$.pipe(
        ofType(EEsProductActions.GetAdditionalProductEs),
        switchMap((action: GetAdditionalProductEs) =>
            this.productService
                .getAdditionalProduct({ contract_id: action.contractId })
                .pipe(mergeMap((addtionalProduct: EsAdditionalProduct) => of(new SetAdditionalProductEs(addtionalProduct))))
        )
    );

    constructor(private actions$: Actions, private productService: ProductEsService) {}
}
